import {
    FC,
    ReactElement,
    useEffect,
    useState,
} from 'react';

import { WishlistItems } from '../../containers';
import { MeilisearchAttribute } from '../../entities/@api/Meilisearch';
import { generateMeilisearchFilterQuery } from '../../entities/@search/Meilisearch/MeilisearchRequests';
import { useTypedSelector } from '../../redux/store';

interface ConnectedWishlistItemsProps {
    className?: string;
}

export const ConnectedWishlistItems: FC<ConnectedWishlistItemsProps> = ({
    className = '',
}): ReactElement => {
    const wishlist = useTypedSelector(state => state.wishlistSlice.wishlist);

    const [productsFilterQuery, setProductsFilterQuery] = useState<string>('');

    useEffect((): void => {
        if (!wishlist.variantIds) {
            return;
        }

        const query = generateMeilisearchFilterQuery(MeilisearchAttribute.id, wishlist.variantIds);

        setProductsFilterQuery(query);
    }, [wishlist]);

    return (
        <WishlistItems
            productsFilterQuery={productsFilterQuery}
            resultsCount={wishlist.variantIds.length}
            className={className}
        />
    );
};
